﻿import config from "../config"
const baseUrl = config.base_url + "container_phenology/"
export default {
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    reorder: {
        url: baseUrl + "reorder",
        type: "post",
    },
    listByContainerId: {
        url: baseUrl + "listByContainerId",
        type: "get",
    },
    listAndReproductiveByContainerId: {
        url: baseUrl + "listAndReproductiveByContainerId",
        type: "get",
    },
    copyToContainer: {
        url: baseUrl + "copyToContainer",
        type: "get",
    },
    listByReproductiveId:{
        url: config.base_url + "container_farm_work_group/listByReproductiveId",
        type: "get",
    },
    saveWithDetail:{
        url: config.base_url + "container_farm_work_group/saveWithDetail",
        type: "post",
    },
    getFarmWorkSelect:{
        url: config.base_url + "container_farm_work_group/getFarmWorkSelect",
        type: "get",
    },
    deleteGroup:{
        url: config.base_url + "container_farm_work_group/deleteGroup",
        type: "get",
    }
} 
